/**
 * this is a class that helps with tracking focus for a11y purposes
 */

export class FocusHelper {
  public active?: HTMLAnchorElement;
  public first: HTMLAnchorElement;
  public focusable: HTMLAnchorElement[];
  public last: HTMLAnchorElement;
  public next: HTMLAnchorElement;
  public previous: HTMLAnchorElement;

  public constructor(
    el: HTMLElement | null // the dropdown container
  ) {
    if (el === null) {
      return;
    }

    const anchors = (this.focusable = Array.from(
      el.querySelectorAll('li a')
    ).filter(e => {
      const parent = e.parentElement;
      return parent
        ? !/disabled/.test(parent.getAttribute('class') || '')
        : false;
    }) as HTMLAnchorElement[]);

    this.first = anchors[0] as HTMLAnchorElement;
    this.last = anchors[anchors.length - 1] as HTMLAnchorElement;

    const { activeElement } = window.document;
    const focused = anchors.filter(a => {
      return a === activeElement;
    });

    this.active = focused.length
      ? (focused[0] as HTMLAnchorElement)
      : undefined;

    if (!this.active) {
      this.next = this.first;
    } else {
      let i = anchors.indexOf(this.active);
      if (i === anchors.length - 1) {
        i = 0;
      } else {
        i = i + 1;
      }
      this.next = anchors[i] as HTMLAnchorElement;
    }

    if (!this.active) {
      this.previous = this.last;
    } else {
      let i = anchors.indexOf(this.active);
      if (i === 0) {
        i = anchors.length - 1;
      } else {
        i = i - 1;
      }
      this.previous = anchors[i] as HTMLAnchorElement;
    }
  }
}
